// import Printable from "components/modules/reporting/A4";
// import React, { useRef } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import { formatDate } from "utils/dateFormatter";
// import logo from "../../../../assets/img/logos/logoNew.png";

// const mockState = {
//   assetAccounts: [
//     { id: 1, name: "Cash", debit: 50000, credit: 0 },
//     { id: 2, name: "Accounts Receivable", debit: 20000, credit: 0 },
//   ],
//   liabilityAccounts: [
//     { id: 3, name: "Accounts Payable", debit: 0, credit: 10000 },
//     { id: 4, name: "Loans", debit: 0, credit: 15000 },
//   ],
//   equityAccounts: [{ id: 5, name: "Owner's Equity", debit: 0, credit: 30000 }],
//   incomeAccounts: [{ id: 6, name: "Sales Revenue", debit: 0, credit: 40000 }],
//   expenseAccounts: [
//     { id: 7, name: "Rent Expense", debit: 10000, credit: 0 },
//     { id: 8, name: "Salaries Expense", debit: 15000, credit: 0 },
//   ],
//   totalAssetsDebit: 70000,
//   totalAssetsCredit: 0,
//   totalLiabilitiesDebit: 0,
//   totalLiabilitiesCredit: 25000,
//   totalEquityDebit: 0,
//   totalEquityCredit: 30000,
//   totalIncomeDebit: 0,
//   totalIncomeCredit: 40000,
//   totalExpensesDebit: 25000,
//   totalExpensesCredit: 0,
//   grandTotalDebit: 95000,
//   grandTotalCredit: 95000,
// };

// export default function TrialBalanceReport() {
//   const navigate = useNavigate();
//   //   const { state } = useLocation();
//   const state = mockState;
//   const printRef = useRef();

//   const triggerPrint = () => {
//     printRef.current?.handlePrint?.();
//   };

//   return (
//     <>
//       <Card>
//         <Card.Header className="border-bottom">
//           <Row className="flex-between-center">
//             <Col md>
//               <div className="d-flex align-items-center">
//                 <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                   Reports | Trial Balance
//                 </h5>
//                 <div className="d-flex align-items-center gap-2 mx-4">
//                   <span style={{ color: "black" }}>From Date:</span>
//                   <Form.Group className="" controlId="formGroupFromDate">
//                     <Form.Control type="date" />
//                   </Form.Group>
//                   <span style={{ color: "black" }}>To Date:</span>
//                   <Form.Group className="" controlId="formGroupToDate">
//                     <Form.Control type="date" />
//                   </Form.Group>
//                 </div>
//               </div>
//             </Col>
//             <Col xs="auto">
//               <Button
//                 variant="link"
//                 className="text-secondary fw-medium p-0 me-3"
//                 type="button"
//                 onClick={() => navigate(-1)}
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" onClick={triggerPrint}>
//                 Print
//               </Button>
//             </Col>
//           </Row>
//         </Card.Header>

//         <Printable ref={printRef} documentTitle="Trial Balance Report">
//           <div style={{ padding: 40, fontFamily: "Arial, sans-serif" }}>
//             {/* Header */}
//             <div className="d-flex justify-content-between">
//               <div>
//                 <div style={{ textAlign: "center", color: "black" }}>
//                   <img
//                     height={80}
//                     width={80}
//                     src={logo}
//                     alt="Logo"
//                     style={{ marginBottom: "20px" }}
//                   />
//                 </div>
//                 <h4 style={{ textAlign: "center", color: "black" }}>
//                   Trial Balance
//                 </h4>
//               </div>
//               <div></div>
//             </div>

//             {/* Reference and Company */}
//             <div className="d-flex justify-content-between my-4">
//               <div>
//                 <strong>Company Name:</strong> ABC Corporation
//                 <br />
//                 <strong>Address:</strong> 123 Main St, City, Country
//               </div>
//               <div className="text-end">
//                 <div>
//                   <strong>REF. NO.:</strong> 123123124
//                 </div>
//                 <div>
//                   <strong>Generated:</strong> {new Date().toLocaleDateString()}
//                 </div>
//               </div>
//             </div>

//             <table style={{ width: "100%", borderCollapse: "collapse" }}>
//               <thead>
//                 <tr>
//                   <th style={styles.th}>ACCOUNT</th>
//                   <th style={styles.th}>DEBIT</th>
//                   <th style={styles.th}>CREDIT</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {/* Assets Group */}
//                 <tr>
//                   <td
//                     style={{
//                       ...styles.td,
//                       fontWeight: "bold",
//                       paddingLeft: 10,
//                     }}
//                   >
//                     ASSETS
//                   </td>
//                   <td style={styles.tdP}></td>
//                   <td style={styles.tdP}></td>
//                 </tr>
//                 {state?.assetAccounts?.map((account) => (
//                   <tr key={account.id}>
//                     <td style={{ ...styles.td, paddingLeft: 30 }}>
//                       {account.name}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.debit?.toLocaleString() || "-"}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.credit?.toLocaleString() || "-"}
//                     </td>
//                   </tr>
//                 ))}
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 20 }}>
//                     Total Assets
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalAssetsDebit?.toLocaleString()}
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalAssetsCredit?.toLocaleString()}
//                   </td>
//                 </tr>

//                 {/* Liabilities Group */}
//                 <tr>
//                   <td
//                     style={{
//                       ...styles.td,
//                       fontWeight: "bold",
//                       paddingLeft: 10,
//                       paddingTop: 15,
//                     }}
//                   >
//                     LIABILITIES
//                   </td>
//                   <td style={styles.tdP}></td>
//                   <td style={styles.tdP}></td>
//                 </tr>
//                 {state?.liabilityAccounts?.map((account) => (
//                   <tr key={account.id}>
//                     <td style={{ ...styles.td, paddingLeft: 30 }}>
//                       {account.name}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.debit?.toLocaleString() || "-"}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.credit?.toLocaleString() || "-"}
//                     </td>
//                   </tr>
//                 ))}
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 20 }}>
//                     Total Liabilities
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalLiabilitiesDebit?.toLocaleString()}
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalLiabilitiesCredit?.toLocaleString()}
//                   </td>
//                 </tr>

//                 {/* Equity Group */}
//                 <tr>
//                   <td
//                     style={{
//                       ...styles.td,
//                       fontWeight: "bold",
//                       paddingLeft: 10,
//                       paddingTop: 15,
//                     }}
//                   >
//                     EQUITY
//                   </td>
//                   <td style={styles.tdP}></td>
//                   <td style={styles.tdP}></td>
//                 </tr>
//                 {state?.equityAccounts?.map((account) => (
//                   <tr key={account.id}>
//                     <td style={{ ...styles.td, paddingLeft: 30 }}>
//                       {account.name}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.debit?.toLocaleString() || "-"}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.credit?.toLocaleString() || "-"}
//                     </td>
//                   </tr>
//                 ))}
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 20 }}>
//                     Total Equity
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalEquityDebit?.toLocaleString()}
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalEquityCredit?.toLocaleString()}
//                   </td>
//                 </tr>

//                 {/* Income Group */}
//                 <tr>
//                   <td
//                     style={{
//                       ...styles.td,
//                       fontWeight: "bold",
//                       paddingLeft: 10,
//                       paddingTop: 15,
//                     }}
//                   >
//                     INCOME
//                   </td>
//                   <td style={styles.tdP}></td>
//                   <td style={styles.tdP}></td>
//                 </tr>
//                 {state?.incomeAccounts?.map((account) => (
//                   <tr key={account.id}>
//                     <td style={{ ...styles.td, paddingLeft: 30 }}>
//                       {account.name}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.debit?.toLocaleString() || "-"}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.credit?.toLocaleString() || "-"}
//                     </td>
//                   </tr>
//                 ))}
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 20 }}>
//                     Total Income
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalIncomeDebit?.toLocaleString()}
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalIncomeCredit?.toLocaleString()}
//                   </td>
//                 </tr>

//                 {/* Expenses Group */}
//                 <tr>
//                   <td
//                     style={{
//                       ...styles.td,
//                       fontWeight: "bold",
//                       paddingLeft: 10,
//                       paddingTop: 15,
//                     }}
//                   >
//                     EXPENSES
//                   </td>
//                   <td style={styles.tdP}></td>
//                   <td style={styles.tdP}></td>
//                 </tr>
//                 {state?.expenseAccounts?.map((account) => (
//                   <tr key={account.id}>
//                     <td style={{ ...styles.td, paddingLeft: 30 }}>
//                       {account.name}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.debit?.toLocaleString() || "-"}
//                     </td>
//                     <td style={styles.tdP}>
//                       {account.credit?.toLocaleString() || "-"}
//                     </td>
//                   </tr>
//                 ))}
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 20 }}>
//                     Total Expenses
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalExpensesDebit?.toLocaleString()}
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.totalExpensesCredit?.toLocaleString()}
//                   </td>
//                 </tr>
//               </tbody>
//               <tfoot>
//                 <tr>
//                   <td style={{ ...styles.tdFT, paddingLeft: 10 }}>
//                     GRAND TOTAL
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.grandTotalDebit?.toLocaleString()}
//                   </td>
//                   <td style={styles.tdF}>
//                     {state?.grandTotalCredit?.toLocaleString()}
//                   </td>
//                 </tr>
//               </tfoot>
//             </table>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginTop: 60,
//               }}
//             >
//               <div>APPROVED BY:</div>
//               <div
//                 style={{ borderBottom: "1px solid #000", width: "250px" }}
//               ></div>
//             </div>
//           </div>
//         </Printable>
//       </Card>
//     </>
//   );
// }

// const styles = {
//   printBtn: {
//     padding: "5px 10px",
//     backgroundColor: "#4CAF50",
//     color: "white",
//     border: "none",
//     borderRadius: "2px",
//     cursor: "pointer",
//     marginRight: "40px",
//   },
//   th: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//     fontWeight: "bold",
//   },
//   td: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//   },
//   tdP: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//   },
//   tdFT: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     backgroundColor: "#e6e6e6",
//     padding: "8px",
//     textAlign: "left",
//   },
//   tdF: {
//     fontWeight: "bold",
//     backgroundColor: "#e6e6e6",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//   },
// };

import Printable from "components/modules/reporting/A4";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Collapse, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/img/logos/logoNew.png";
import { formatDateRange } from "utils/formatter";
import { useSettingContext } from "context/SettingContext";
import { useFetchFinanceBook } from "hooks/useFetchFinanceBook";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import ReactDatePickerE from "components/common/ReactDatePickerE";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const mockState = {
  assetAccounts: [
    {
      id: 1,
      name: "Cash",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
    {
      id: 2,
      name: "Accounts Receivable",
      openingDr: 20000,
      openingCr: 0,
      debit: 20000,
      credit: 0,
      closingDr: 20000,
      closingCr: 0,
    },
  ],
  liabilityAccounts: [
    {
      id: 3,
      name: "Accounts Payable",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
    {
      id: 4,
      name: "Loans",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
  ],
  equityAccounts: [
    {
      id: 5,
      name: "Owner's Equity",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
  ],
  incomeAccounts: [
    {
      id: 6,
      name: "Sales Revenue",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
  ],
  expenseAccounts: [
    {
      id: 7,
      name: "Rent Expense",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
    {
      id: 8,
      name: "Salaries Expense",
      openingDr: 50000,
      openingCr: 0,
      debit: 50000,
      credit: 0,
      closingDr: 50000,
      closingCr: 0,
    },
  ],
  totalAssetsOpeningDebit: 70000,
  totalAssetsOpeningCredit: 0,
  totalAssetsDebit: 70000,
  totalAssetsCredit: 0,
  totalAssetsClosingDebit: 70000,
  totalAssetsClosingCredit: 0,
  totalLiabilitiesOpeningDebit: 0,
  totalLiabilitiesOpeningCredit: 25000,
  totalLiabilitiesDebit: 0,
  totalLiabilitiesCredit: 25000,
  totalLiabilitiesClosingDebit: 0,
  totalLiabilitiesClosingCredit: 25000,
  totalEquityOpeningDebit: 0,
  totalEquityOpeningCredit: 30000,
  totalEquityDebit: 0,
  totalEquityCredit: 30000,
  totalEquityClosingDebit: 0,
  totalEquityClosingCredit: 30000,
  totalIncomeOpeningDebit: 0,
  totalIncomeOpeningCredit: 40000,
  totalIncomeDebit: 0,
  totalIncomeCredit: 40000,
  totalIncomeClosingDebit: 0,
  totalIncomeClosingCredit: 40000,
  totalExpensesOpeningDebit: 25000,
  totalExpensesOpeningCredit: 0,
  totalExpensesDebit: 25000,
  totalExpensesCredit: 0,
  totalExpensesClosingDebit: 25000,
  totalExpensesClosingCredit: 0,
  grandTotalOpeingDebit: 95000,
  grandTotalOpeingCredit: 95000,
  grandTotalDebit: 95000,
  grandTotalCredit: 95000,
  grandTotalClosingDebit: 95000,
  grandTotalClosingCredit: 95000,
};

export default function TrialBalanceReport() {
  const navigate = useNavigate();
  const state = mockState;
  const printRef = useRef();
  const headerRef = useRef();
  const collapseButtonRef = useRef();
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [fromDate, setFromDate] = useState(formatDateRange(firstDayOfMonth));
  const [toDate, setToDate] = useState(formatDateRange(today));
  const [reportData, setReportData] = useState(null);
  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  const settingsData = useSettingContext();
  const costCenter = useMemo(
    () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
    [settingsData]
  );
  const costCenterId = Number(costCenter?.value) || 1; // Ensure it's a number

  const { data: financeBooksData, isLoading: financeBookLoading } =
    useFetchFinanceBook(costCenterId);

  const [collapseIn, setCollapseIn] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const toggleFilters = () => setCollapseIn(!collapseIn);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const rect = headerRef.current.getBoundingClientRect();
        setIsHeaderVisible(rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <PageTitle name="Reports | Trial Balance" />
      <Card>
        {/* <Card.Header className="border-bottom">
        <Row className="flex-between-center">
          <Col md>
            <div className="d-flex align-items-center">
              <h5
                className="fs-9 text-nowrap mb-2 mb-md-0"
                style={{ width: "19.5rem" }}
              >
                Reports | Trial Balance
              </h5>
              <div className="d-flex align-items-center gap-2">
                <Form.Select
                  aria-label="Fiscal Year"
                  className="fs-9"
                  style={{ width: "200px" }}
                >
                  <option value="">Finance Book</option>
                  {financeBooksData?.data.data.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>
                <span style={{ color: "black" }}>From:</span>
                <Form.Group className="" controlId="formGroupFromDate">
                  <Form.Control
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </Form.Group>
                <span style={{ color: "black" }}>To:</span>
                <Form.Group className="" controlId="formGroupToDate">
                  <Form.Control
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </Form.Group>
              </div>
            </div>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={triggerPrint}>
              Print
            </Button>
          </Col>
        </Row>
      </Card.Header> */}

        <Card.Header
          ref={headerRef}
          className="border-bottom sticky-header"
          style={{
            position: "sticky",
            top: -90,
            backgroundColor: "white",
            zIndex: 1000,
            paddingBottom: collapseIn ? "1rem" : "1.5rem",
            transition: "padding-bottom 0.3s ease",
          }}
        >
          <div className="header-content">
            <Row className="flex-between-center align-items-center">
              <Col md>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  {/* <h5
                    className="fs-9 text-nowrap mb-2 mb-md-0"
                    style={{ width: "19.5rem" }}
                  >
                    Reports | Trial Balance
                  </h5> */}
                  <div style={{ width: "19.5rem" }}>
                    <BreadCrumbTable title="Reports" subTitle="Trial Balance" />
                  </div>
                  <div style={{ color: "black" }}>Date Range:</div>
                  <div style={{ width: "280px" }}>
                    <ReactDatePickerE />
                  </div>
                </div>
              </Col>
              <Col xs="auto">
                <Button
                  variant="link"
                  className="text-secondary fw-medium p-0 me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                {reportData ? (
                  <>
                    <Button variant="primary" onClick={triggerPrint}>
                      Print
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="primary">Preview</Button>
                  </>
                )}
              </Col>
            </Row>

            <Collapse in={collapseIn}>
              <div className="filter-row">
                <Row className="mt-3">
                  <Col
                    md="auto"
                    style={{
                      marginLeft: "20rem",
                      display: "flex",
                      gap: 10,
                    }}
                  >
                    <Form.Select
                      aria-label="Fiscal Year"
                      className="fs-9"
                      style={{ width: "180px" }}
                    >
                      <option value="">Finance Book</option>
                      {financeBooksData?.data.data.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>

          {/* Collapse toggle button fixed to border-bottom */}
          <div
            ref={collapseButtonRef}
            style={{
              position: "absolute",
              right: "7.5rem",
              bottom: "-15px",
              zIndex: 1001,
              backgroundColor: "white",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px white",
              visibility: isHeaderVisible ? "visible" : "hidden",
              transition: "visibility 0.2s ease",
            }}
          >
            {collapseIn ? (
              <IoIosArrowDropup
                title="Hide Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            ) : (
              <IoIosArrowDropdown
                title="Show Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            )}
          </div>
        </Card.Header>

        <Printable ref={printRef} documentTitle="Trial Balance Report">
          {reportData && (
            <div style={{ padding: 40, fontSize: "14px" }}>
              {/* Header */}
              <div className="d-flex justify-content-between">
                <div>
                  <div style={{ textAlign: "center", color: "black" }}>
                    <img
                      height={80}
                      width={80}
                      src={logo}
                      alt="Logo"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                  <h4 style={{ textAlign: "center", color: "black" }}>
                    Trial Balance
                  </h4>
                </div>
                <div></div>
              </div>

              {/* Reference and Company */}
              <div className="d-flex justify-content-between my-4">
                <div>
                  <strong>Company Name:</strong> ABC Corporation
                  <br />
                  <strong>Address:</strong> 123 Main St, City, Country
                </div>
                <div className="text-end">
                  <div>
                    <strong>Period:</strong> 24-05-2024
                  </div>
                  <div>
                    <strong>Printed:</strong> {new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* Trial Balance Table */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    {/* <tr>
                  <th colSpan={3} style={styles.toPth}>
                    TRIAL BALANCE
                  </th>
                </tr> */}
                    <tr>
                      <th style={styles.toPth}>ACCOUNT</th>
                      <th style={styles.toPth}>OPENING (DR)</th>
                      <th style={styles.toPth}>OPENING (CR)</th>
                      <th style={styles.toPth}>DEBIT</th>
                      <th style={styles.toPth}>CREDIT</th>
                      <th style={styles.toPth}>CLOSING (DR)</th>
                      <th style={styles.toPth}>CLOSING (CR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Assets Section */}
                    <tr>
                      <td
                        colSpan="7"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>ASSETS</span>
                      </td>
                    </tr>
                    {state.assetAccounts.map((account) => (
                      <tr key={account.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {account.name}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingCr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.debit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.credit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingCr)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Assets
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalAssetsOpeningDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalAssetsOpeningCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalAssetsDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalAssetsCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalAssetsClosingDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalAssetsClosingCredit)}
                      </td>
                    </tr>

                    {/* Liabilities Section */}
                    <tr>
                      <td
                        colSpan="7"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>LIABILITIES</span>
                      </td>
                    </tr>
                    {state.liabilityAccounts.map((account) => (
                      <tr key={account.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {account.name}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingCr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.debit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.credit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingCr)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Liabilities
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLiabilitiesOpeningDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLiabilitiesOpeningCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLiabilitiesDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLiabilitiesCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLiabilitiesClosingDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalLiabilitiesClosingCredit)}
                      </td>
                    </tr>

                    {/* Equity Section */}
                    <tr>
                      <td
                        colSpan="7"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>EQUITY</span>
                      </td>
                    </tr>
                    {state.equityAccounts.map((account) => (
                      <tr key={account.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {account.name}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingCr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.debit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.credit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingCr)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Equity
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquityOpeningDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquityOpeningCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquityDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquityCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquityClosingDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalEquityClosingCredit)}
                      </td>
                    </tr>

                    {/* Income Section */}
                    <tr>
                      <td
                        colSpan="7"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>INCOME</span>
                      </td>
                    </tr>
                    {state.incomeAccounts.map((account) => (
                      <tr key={account.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {account.name}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingCr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.debit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.credit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingCr)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Income
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalIncomeOpeningDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalIncomeOpeningCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalIncomeDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalIncomeCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalIncomeClosingDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalIncomeClosingCredit)}
                      </td>
                    </tr>

                    {/* Expenses Section */}
                    <tr>
                      <td
                        colSpan="7"
                        style={{ ...styles.tdGroup, paddingLeft: "18px" }}
                      >
                        <span style={{ fontSize: 14 }}>EXPENSES</span>
                      </td>
                    </tr>
                    {state.expenseAccounts.map((account) => (
                      <tr key={account.id}>
                        <td style={{ ...styles.td, paddingLeft: "30px" }}>
                          {account.name}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.openingCr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.debit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.credit)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingDr)}
                        </td>
                        <td style={styles.tdP}>
                          {formatAmount(account.closingCr)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...styles.tdSubtotal, paddingLeft: "30px" }}>
                        Total Expenses
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalExpensesOpeningDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalExpensesOpeningCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalExpensesDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalExpensesCredit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalExpensesClosingDebit)}
                      </td>
                      <td style={styles.tdSubtotalP}>
                        {formatAmount(state.totalExpensesClosingCredit)}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ ...styles.tdTotal, paddingLeft: "10px" }}>
                        <strong>GRAND TOTAL</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>
                          {formatAmount(state.grandTotalOpeingDebit)}
                        </strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>
                          {formatAmount(state.grandTotalOpeingCredit)}
                        </strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(state.grandTotalDebit)}</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(state.grandTotalCredit)}</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>
                          {formatAmount(state.grandTotalClosingDebit)}
                        </strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>
                          {formatAmount(state.grandTotalClosingCredit)}
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Approval Signature */}
              <div
                style={{
                  marginTop: 100,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ width: 300, textAlign: "center" }}>
                  <div
                    style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
                  ></div>
                  <div>Authorized Signature</div>
                </div>
              </div>
            </div>
          )}
        </Printable>
      </Card>
    </>
  );
}

const border = "1px solid #000";
const basePadding = "8px 10px";
const baseTextAlignLeft = "left";
const baseTextAlignRight = "right";

const bg = {
  lightGray: "#f8f8f8",
  gray: "#e6e6e6",
  darkGray: "#A9A9A9",
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
  },
  toPth: {
    backgroundColor: bg.darkGray,
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
  },
  th: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.gray,
    fontWeight: "bold",
  },
  td: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
  },
  tdP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
  },
  tdGroup: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.gray,
    fontWeight: "bold",
  },
  tdSubtotal: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.lightGray,
  },
  tdSubtotalP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.lightGray,
  },
  tdTotal: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdTotalP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
};
